export default __webpack_public_path__ + "static/media/passleftgraphics.e876c444.svg";